import { render, staticRenderFns } from "./CreateBot.vue?vue&type=template&id=235d46c4&"
import script from "./CreateBot.vue?vue&type=script&lang=js&"
export * from "./CreateBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports